export default {
  //
  // ============================================================================
  // LOGIN HEADER
  // ============================================================================
  //
  loginHeader: {
    labSubtitle: "Лабораторна информационна система",
    defaultLabName: "Лабораторен портал",
    defaultLogoAlt: "Лого на лабораторията",
    signIn: "Вход",
    openMenu: "Отваряне на меню",
    language_section: {
      title: "Избиране на език",

      languages: {
        en: "Английски",
        bg: "Български",
        mk: "Македонски",
      },
    },
  },

  //
  // ============================================================================
  // LOGIN FORM
  // ============================================================================
  //
  loginForm: {
    title: "Уеб Портал за онлайн резултати",
    description:
      "Изтеглете Вашите резултати онлайн, без да губите време в повторно посещение. За лекари и медицински партньори - специални функции за проследяване на пациенти.",
    loginButtonText: "Вход в системата",
    agreeTerms: "Съгласявам се с",
    termsOfUse: "Условията за ползване",
    termsOfUseTooltip: "Преглед на условията за ползване",
    termsDialogTitle: "Условия за ползване",
    termsDialogOk: "Разбрах",
    termsLoadingError: "Неуспешно зареждане на условията за ползване. Моля, опитайте отново.",
    termsLoadingText: "Зареждане на условията за ползване...",
    scrollToBottom: "Моля, превъртете до края, за да продължите",
    scrollToBottomButton: "Превъртане до края",
  },

  //
  // ============================================================================
  // LOGIN FOOTER
  // ============================================================================
  //
  loginFooter: {
    // === General Information ===
    subtitle: "Лабораторна информационна система",
    poweredBy: "Задвижвана от",
    description:
      "Модерна LIMS платформа за управление на лабораторни процеси, изследвания и резултати.",
    disclaimer:
      "Системата е достъпна само за оторизирани потребители. За данни за достъп се свържете с лабораторията.",

    // === Resources Section ===
    resources: "Медицински услуги",
    labTests: "Изследвания",
    labTestsTooltip: "Преглед на каталога с лабораторни изследвания",
    pricing: "Ценоразпис",
    pricingTooltip: "Преглед на цени и пакети",
    covidTesting: "COVID-19",
    covidTestingTooltip: "Услуги за COVID-19 тестване",
    documentation: "Документация",
    documentationTooltip: "Преглед на документацията",

    // === Product Information ===
    lisILab: "LIMS iLab",
    limsILabTooltip: "LIMS iLab - Лабораторна информационна система",

    // === Contact Section ===
    connect: "Свържете се с нас",
    locationDetails: "София",
    locationDetailsTooltip: "Посещение",
    phone: "Телефон",
    phoneNumber: "+359 2 XXX XXXX",
    phoneTooltip: "Обаждане",
    email: "Имейл",
    emailAddress: "info-precisio.bg",
    emailTooltip: "Изпращане на имейл",
    workingHoursDetails: "Пон-Пет: 07:30-19:00",
    workingHoursTooltip: "Работно време на лабораторията",

    // === Company & Copyright ===
    skywareGroup: "СКАЙУЕР Груп",
    skywareGroupUrl: "https://skyware-group.com",
    skywareGroupTooltip: "Посещение на уебсайта на СКАЙУЕР Груп",
    github: "GitHub",
    nuget: "NuGet",
    copyrightPrefix: "Авторско право ©",
    versionLabel: "версия",

    // === Social Media ===
    socialGitHub: "GitHub",
    socialGitHubTooltip: "Преглед в GitHub",
    socialLinkedIn: "LinkedIn",
    socialLinkedInTooltip: "Последване в LinkedIn",
    socialEmail: "Имейл",
    socialEmailTooltip: "Контакт чрез имейл",
  },
};
